import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpParams } from '@angular/common/http';
import { trigger, transition, style, animate } from '@angular/animations';
import { ConfigurationState, ReportTemplate, ReportTemplatesRepositoryService } from 'reg-hub-common';

@Component({
    selector: 'app-report-templates-list',
    templateUrl: './report-templates-list.component.html',
    styleUrls: ['./report-templates-list.component.css'],
    animations: [
        trigger('fadeIn', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('300ms ease-in', style({ opacity: 1 })),
            ]),
        ]),
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportTemplatesListComponent implements OnInit {
    allReports: ReportTemplate[] = [];
    filteredReports: ReportTemplate[] = [];

    constructor(
        private repo: ReportTemplatesRepositoryService,
        private configurationState: ConfigurationState) { }

    ngOnInit(): void {
        let params = new HttpParams()
            .set('PageSize', 100)
            .set('sortColumn', 'Name');

        this.configurationState.getCorporationID().then(corporationID => {

            this.repo.populateBaseLink([corporationID]);

            this.repo.getFirstPageSubscribable(params).subscribe((results) => {
                this.allReports = results;
                this.filteredReports = results;
            });
        });
    }

    filterReports(event: Event) {
        const inputElement = event.target as HTMLInputElement;
        const searchTerm = inputElement.value ?? '';

        if (!searchTerm) {
            this.filteredReports = this.allReports;
        } else {
            const lowerSearchTerm = searchTerm.toLowerCase();
            this.filteredReports = this.allReports.filter((report) =>
                report.name?.toLowerCase().includes(lowerSearchTerm) ||
                (report.description && report.description.toLowerCase().includes(lowerSearchTerm))
            );
        }
    }
}